/**
 * Nova Multi Currency Converter: show "AED" (not "Dhs"), remove commas from prices,
 * and round prices (last digit < 5 → end in 5, last digit >= 5 → end in 9).
 * Runs on load and observes DOM changes so dynamically loaded prices are updated.
 */
(function () {
  var TARGET = 'Dhs';
  var REPLACEMENT = 'AED';
  var PRICE_SELECTOR = 'price-list, sale-price, compare-at-price, [class*="price-list"], [class*="product-individual-price"], [class*="product-you-might-like-price"]';

  function isPriceContext(node) {
    var el = node.parentElement;
    return el && el.closest && el.closest(PRICE_SELECTOR);
  }

  function roundPrice(n) {
    var num = Math.floor(parseFloat(String(n).replace(/,/g, '')));
    if (!isFinite(num)) return n;
    var lastDigit = num % 10;
    var base = Math.floor(num / 10) * 10;
    return lastDigit < 5 ? base + 5 : base + 9;
  }

  function formatPrice(numStr) {
    var num = parseFloat(String(numStr).replace(/,/g, ''));
    if (!isFinite(num)) return numStr;
    var rounded = roundPrice(num);
    return String(rounded);
  }

  function replaceInTextNode(node) {
    if (node.nodeType !== Node.TEXT_NODE) return;
    var text = node.textContent;

    if (text.includes(TARGET) || text.includes('AED.')) {
      text = text.replace(/\bDhs\./g, REPLACEMENT).replace(/\bDhs\b/g, REPLACEMENT).replace(/\bAED\./g, REPLACEMENT);
    }

    if (isPriceContext(node) && /\d{1,3}(?:,\d{3})/.test(text)) {
      text = text.replace(/\d{1,3}(?:,\d{3})+(?:\.\d+)?/g, function (match) {
        return formatPrice(match);
      });
    }

    if (text !== node.textContent) node.textContent = text;
  }

  function walkAndReplace(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceInTextNode);
  }

  function run() {
    walkAndReplace(document.body);
  }

  function startObserver() {
    run();
    // Nova may update prices after load; run again after short delays
    setTimeout(run, 500);
    setTimeout(run, 1500);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) walkAndReplace(node);
          else if (node.nodeType === Node.TEXT_NODE) replaceInTextNode(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
